const basicAuthenticationConfig = (email, password) => {
  return {
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Basic " + btoa(email + ":" + password)
    }
  };
};

export default basicAuthenticationConfig;
